class FreeShippingDrawer {
  constructor() {
    this.defaultMessage = 'Agrega {currency}{amount} más y obtén ENVÍO GRATIS en tu pedido';
    this.defaultReachedMessage = '¡Felicidades! Tienes ENVÍO GRATIS';
    this.highlightText = 'ENVÍO GRATIS';

    this.handleCartEvent = this.handleCartEvent.bind(this);
    this.refresh = this.refresh.bind(this);

    this.bindElements();
    this.initEvents();
    this.refresh();
  }

  bindElements() {
    this.el = document.querySelector('[data-free-shipping]');
    this.fill = this.el?.querySelector('.free-shipping-drawer__bar-fill') || null;
    this.textEl = this.el?.querySelector('.free-shipping-drawer__text') || null;
    this.thresholdCents = Number.parseInt(this.el?.dataset.thresholdCents || '', 10) || 0;
    this.messageTemplate = this.el?.dataset.messageTemplate || this.defaultMessage;
    this.reachedMessage = this.el?.dataset.reachedMessage || this.defaultReachedMessage;
    this.currency = this.el?.dataset.currency || window.Shopify?.currency?.active || '';

    return Boolean(this.el && this.fill && this.textEl && this.thresholdCents > 0);
  }

  initEvents() {
    [
      'cart:updated',
      'cart:change',
      'cart_update',
      'cart:refresh',
      'cart.requestComplete',
      'product:added',
      'shopify:section:load',
    ].forEach((eventName) => {
      document.addEventListener(eventName, this.handleCartEvent);
    });
  }

  handleCartEvent(event) {
    const cart = event?.detail?.cart || event?.detail;

    if (cart && typeof cart.total_price !== 'undefined') {
      this.update(cart);
      return;
    }

    this.refresh();
  }

  update(cart) {
    if (!this.bindElements() || !cart) return;

    const totalCents = Number(cart.total_price) || 0;
    const remainingCents = Math.max(0, this.thresholdCents - totalCents);
    const progress = Math.min(100, Math.round((totalCents / this.thresholdCents) * 100));

    this.setProgress(progress, remainingCents);
  }

  refresh() {
    if (!this.bindElements()) return;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => this.update(cart))
      .catch((error) => {
        console.error('Error updating free shipping drawer:', error);
      });
  }

  setProgress(progress, remainingCents) {
    this.fill.style.width = `${progress}%`;
    this.fill.dataset.progress = progress;

    if (progress >= 100) {
      this.el.classList.add('free-shipping-drawer--reached');
      this.setText(this.reachedMessage);
      return;
    }

    this.el.classList.remove('free-shipping-drawer--reached');

    const amountFormatted = this.formatMoney(remainingCents);
    const message = this.messageTemplate
      .replace('{currency}{amount}', amountFormatted)
      .replace('{currency}', this.currency)
      .replace('{amount}', amountFormatted);

    this.setText(message);
  }

  setText(message) {
    if (!this.textEl) return;

    if (message.includes(this.highlightText)) {
      this.textEl.innerHTML = message.replace(this.highlightText, `<span>${this.highlightText}</span>`);
      return;
    }

    this.textEl.textContent = message;
  }

  formatMoney(amountCents) {
    if (typeof formatMoney === 'function' && window.MinimogSettings?.money_format) {
      return formatMoney(amountCents, window.MinimogSettings.money_format);
    }

    const amount = amountCents / 100;
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || window.MinimogSettings?.currency_code || 'USD',
    }).format(amount);
  }
}

if (!window.freeShippingDrawer) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.freeShippingDrawer = new FreeShippingDrawer();
    });
  } else {
    window.freeShippingDrawer = new FreeShippingDrawer();
  }
} else {
  window.freeShippingDrawer.refresh();
}
